// @module Tavanoteam.RecentlyPurchased.RecentlyPurchased
define('Tavanoteam.RecentlyPurchased.RecentlyPurchased.View'
	, [
		'Extended.ItemRelations.RelatedItem.View'
		, 'Extended.ReorderItems.Collection'

		, 'item_relations_cell.tpl'
		, 'item_relations_row.tpl'
		, 'extended_item_relations_related.tpl'

		, 'Backbone.CollectionView'
		, 'jQuery'
		, 'underscore'
		, 'Utils'
	]
	, function (
		ExtendedItemRelationsRelatedItemView
		, ExtendedReorderItemsCollection

		, item_relations_cell_tpl
		, item_relations_row_tpl
		, extended_item_relations_related_tpl

		, BackboneCollectionView
		, jQuery
		, _
		, Utils
	) {
		'use strict';

		// @class Tavanoteam.RecentlyPurchased.RecentlyPurchased.View @extends Backbone.View
		return BackboneCollectionView.extend({

			initialize: function (options) {
				var siteConfig = this.options.container.getConfig(),
					layout = this.options.container.getLayout(),
					self = this;

				this.collection = new ExtendedReorderItemsCollection();
				this.is_sca_advanced = siteConfig.siteSettings.sitetype

				BackboneCollectionView.prototype.initialize.call(this, {
					collection: this.collection,
					viewsPerRow: Infinity,
					cellTemplate: item_relations_cell_tpl,
					rowTemplate: item_relations_row_tpl,
					childView: ExtendedItemRelationsRelatedItemView,
					template: extended_item_relations_related_tpl
				});

				this.loadRelatedItems();
			}

			, render: function () {
				BackboneCollectionView.prototype.render.call(this);
				if (this.is_sca_advanced) {
					var layout = this.options.container.getLayout();
					if (!jQuery.contains(document.documentElement, this.$el[0])) {
						layout.once('afterAppendView', this.carouselInitialize, this);
					}
					else {
						this.carouselInitialize();
					}
				}
				return this;
			}

			, carouselInitialize: function carouselInitialize() {
				var carousel = this.$el.find('[data-type="carousel-items"]');
				var _a = this.options.container.getConfig(), siteSettings = _a.siteSettings, imageSizeMapping = _a.imageSizeMapping, bxSliderDefaults = _a.bxSliderDefaults;
				if (carousel.length > 0) {
					if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
						var img_min_height = _.where(siteSettings.imagesizes, {
							name: imageSizeMapping.thumbnail
						})[0].maxheight;
						carousel
							.find('.item-relations-related-item-thumbnail')
							.css('minHeight', img_min_height);
					}

					var itemsPerSlide = 5;

					bxSliderDefaults.maxSlides = itemsPerSlide;

					Utils.initBxSlider(carousel, bxSliderDefaults);
				}
			}

			, loadRelatedItems: function loadRelatedItems() {
				var self = this,
					imageSizes = self.options.container.getConfig().siteSettings.imagesizes;

				self.collection.fetch().done(function () {
					self.render();
				});
			}

			, destroy: function destroy() {
				this._destroy();
				this.off('afterCompositeViewRender', this.loadRelatedItems, this);
			}
		});
	});
